import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
} from 'chart.js';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import styles from './MileageSaarathi.module.css';
import CustomSelectButton from './CustomSelectButton'
import ChartLoader from './Loader_MS_bus';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Title, Legend);

const FleetEnergyChart = (props) => {
  const { filterdata } = props

  const [filterData, setFilterData] = useState({ startDate: "", endDate: "" })


  const [labels, setLabels] = useState([]);
  const [energyData, setEnergyData] = useState([]);
  const [distanceData, setDistanceData] = useState([]);
  const [filterType, setFilterType] = useState('Day on Day');
  const [vinNo, setVinNumber] = useState([])
  const [regNo, setRegNumber] = useState([])
  const [selectedField, setSelectedField] = useState("VIN_NUM")
  const [dateRange, setDataRange] = useState([])

  const { isLoading, sendReq: fetchData } = useHttp();



  const fetchChartData = (filterType) => {
    let apiUrl = '';
    const endDate = new Date(); // today
    endDate.setDate(endDate.getDate() - 1); // yesterday

    let startDate = new Date(endDate);

    switch (filterType) {
      case "Day on Day":
        startDate.setDate(endDate.getDate() - 6); // Last 7 days
        break;
      case "Week on Week":
        startDate.setDate(endDate.getDate() - 7 * 6); // Last 6 weeks (42 days)
        break;
      case "Month on Month":
        startDate.setMonth(endDate.getMonth() - 3); // Last 3 months
        break;
      default:
        return;
    }

    const formatDate = (date) => date.toISOString().split("T")[0];
    let body = {

      filterdata: {
        ...filterdata,
        // startDate: formatDate(startDate),
        // endDate: formatDate(endDate),
        VIN_NUM: selectedField === "VIN_NUM" ? vinNo : [],
        REG_NUM: selectedField === "REG_NUM" ? regNo : []
      }
    }

    if (filterType === 'Day on Day') {
      apiUrl = 'mileage_sarathi/fleet_summary_Fleet_Energy_Efficiency_Day_on_Day';
    } else if (filterType === 'Week on Week') {
      apiUrl = 'mileage_sarathi/fleet_summary_Fleet_Energy_Efficiency_Week_on_Week';
    } else if (filterType === 'Month on Month') {
      apiUrl = 'mileage_sarathi/fleet_summary_Fleet_Energy_Efficiency_Month_on_Month';
    }

    fetchData(
      {
        url: API_URL_MAIN + apiUrl,
        body,
      },
      (data) => {
        const newLabels = data?.map((bucket, index) => {
          if (filterType === 'Day on Day') {
            return new Date(bucket.key).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
            })
          } else if (filterType === 'Week on Week') {
            return `Week ${index + 1}`;
          } else if (filterType === 'Month on Month') {
            return new Date(bucket.key).toLocaleDateString('en-GB', {
              month: 'long'
            });
          } else {
            return '';
          }
        }
        );
        const energy = data?.map((bucket) => bucket?.Energy_Efficiency?.value?.toFixed(2));
        const distance = data?.map((bucket) => bucket?.Distance?.value);
        const newDateRange = data?.map((bucket) => {
          if (filterType === 'Day on Day') {
            return bucket.key_as_string + " to " + bucket.key_as_string
          }
          else if (filterType === 'Week on Week') {
            const sunday = new Date(bucket.key_as_string);

            // Calculate Saturday by adding 6 days to Sunday
            const saturday = new Date(sunday);
            saturday.setDate(sunday.getDate() + 6);

            // Format function for DD-MM-YY
            const formatDate = (date) => {
              const dd = date.getDate().toString().padStart(2, '0');
              const mm = (date.getMonth() + 1).toString().padStart(2, '0');
              const yy = date.getFullYear().toString().slice(-2);
              return `${dd}-${mm}-${yy}`;
            };

            return `${formatDate(sunday)} to ${formatDate(saturday)}`;

          } else if (filterType === 'Month on Month') {
            const date = new Date(bucket.key);
            const year = date.getFullYear().toString().slice(-2); // last 2 digits of year
            const month = (date.getMonth() + 1).toString().padStart(2, '0');

            const startDay = '01';
            const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate().toString().padStart(2, '0');

            return `${startDay}-${month}-${year} to ${lastDate}-${month}-${year}`;
          } else {
            return '';
          }
        }
        );

        setDataRange(newDateRange)
        setLabels(newLabels);
        setEnergyData(energy);
        setDistanceData(distance);
      }
    );
  };


  // Fetch data for the default filter ('Day on Day')
  useEffect(() => {
    fetchChartData(filterType);
  }, [filterdata, filterType, vinNo, regNo, selectedField]);

  // Handle dropdown change
  const handleFilterChange = (event) => {
    const selectedFilter = event.target.value;
    setFilterType(selectedFilter);
    fetchChartData(selectedFilter);
  };

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Energy Efficiency',
        data: energyData,
        backgroundColor: '#83a4cf',
        yAxisID: 'yLeft',
      },
      {
        label: 'Distance',
        data: distanceData,
        backgroundColor: '#cddaea',
        yAxisID: 'yRight',
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yLeft: {
        type: 'linear',
        position: 'left',
        beginAtZero: true,
        min: 0,
        title: {
          display: true,
          text: 'Energy Efficiency',
        },
        ticks: {
          stepSize: 0.5,
        },
      },
      yRight: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Distance',
        },
        grid: {
          drawOnChartArea: false,
        },
      },
    },
    plugins: {
      tooltip: {
        enabled: false,
        external: function (context) {
          let tooltipEl = document.getElementById('chartjs-tooltip');
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.style.background = 'white';
            tooltipEl.style.border = '1px solid #ccc';
            tooltipEl.style.borderRadius = '8px';
            tooltipEl.style.padding = '8px 12px';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.transform = 'translate(-50%, 0)';
            tooltipEl.style.whiteSpace = 'nowrap';
            tooltipEl.style.fontSize = '14px';
            tooltipEl.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
            document.body.appendChild(tooltipEl);
          }

          const tooltipModel = context.tooltip;

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          if (tooltipModel.dataPoints) {
            const index = tooltipModel.dataPoints[0].dataIndex;
            const energy = energyData[index];
            const dist = distanceData?.[index]?.toLocaleString();

            tooltipEl.innerHTML = ` 
              <div style="display: flex; align-items: center; margin-bottom: 4px;">
                <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#83a4cf;margin-right:8px;"></span>
                Energy Efficiency = ${energy}
              </div>
              <div style="display: flex; align-items: center;">
                <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:#cddaea;margin-right:8px;"></span>
                Distance = ${dist}
              </div>
            `;
          }

          const position = context.chart.canvas.getBoundingClientRect();

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left =
            position.left + window.pageXOffset + tooltipModel.caretX + 'px';
          tooltipEl.style.top =
            position.top + window.pageYOffset + tooltipModel.caretY - 40 + 'px';
        },
      },
      legend: { display: false },
      datalabels: { display: false },
    },
  };

  const updateFilter = (arr, index) => {
    setVinNumber(arr)
  }
  const updateFilterForREGNo = (arr, index) => {
    setRegNumber(arr)
  }


  const downloadData = (e) => {
    e.preventDefault()
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const excelFileName = `Fleet Graph and Insight Data`;

    const flatData = labels?.map((item, index) => ({
      'Labels': item,
      'Energy Efficiency': energyData?.[index] ?? '-',
      'Distance': distanceData?.[index] ?? '-',
      'Date Range': dateRange?.[index] ?? '-'

    }));

    const ws = XLSX.utils.json_to_sheet(flatData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, excelFileName + fileExtension);

  }

  return (
    <div className="card mb-3 p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className={`m-0 fw-bold ${styles.date_range_selection}`}>Fleet Energy Efficiency</h6>
        <div className="d-flex">
          <a href="#" className={`text-decoration-none ${styles.download_button} ${isLoading ? 'text-muted' : ""}`}
            style={{ pointerEvents: isLoading ? "none" : "" }}
            onClick={(e) => downloadData(e)}>
            <i className="fas fa-download me-1"></i>Download Report
          </a>
          <div className="ms-4">
            <h6 className="m-0 fw-bold">Growth Tracking Insights</h6>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-8">
          <div className="row mb-3">
            <div className="col-md-3">
              <select className={`form-select ${styles.filter_dropdown}`} value={filterType} onChange={handleFilterChange}>
                <option value="Day on Day">Day on Day</option>
                <option value="Week on Week">Week on Week</option>
                <option value="Month on Month">Month on Month</option>
              </select>
            </div>
            <div className="col-md-3">
              <select className={`form-select ${styles.filter_dropdown}`} value={selectedField} onChange={(e) => setSelectedField(e.target.value)}>
                <option value="VIN_NUM">VIN No.</option>
                <option value="REG_NUM">Reg. No.</option>
              </select>
            </div>
            <div className="col-md-4">
              {
                selectedField == "VIN_NUM" ?
                  <CustomSelectButton apiEnd="fleet_summary_Vehicle_no_filter" filterdata={filterdata} updateFilter={updateFilter} />
                  :
                  <CustomSelectButton apiEnd="fleet_summary_registeration_no_filter" filterdata={filterdata} updateFilter={updateFilterForREGNo} />
              }

            </div>
          </div>

          <div className="d-flex justify-content-end mb-2 gap-3">
            <div className="d-flex align-items-center">
              <span className={styles.graph_circles_energy}></span>
              <span>Energy Efficiency</span>
            </div>
            <div className="d-flex align-items-center">
              <span className={styles.graph_circles_distance}></span>
              <span>Distance</span>
            </div>
          </div>

          <div style={{ height: '400px', width: '100%' }}>
            {
              isLoading ? <ChartLoader />
                : <Bar data={chartData} options={chartOptions} />
            }

          </div>
        </div>

        <div className="col-md-4">
          <div style={{ backgroundColor: "#E8EBEC", height: "500px", width: '80%', float: "right" }}>
            <div className='mt-5' style={{ fontSize: "20px" }}>
              Coming Soon
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetEnergyChart;
